import React from "react"
import styled from "@emotion/styled"

const BouncingLoader = () => (
  <LoaderWrapper className="bouncing-loader">
    <div />
    <div />
    <div />
  </LoaderWrapper>
)

const LoaderWrapper = styled.div`
  @keyframes bouncing-loader {
    to {
      opacity: 0.1;
      transform: translate3d(0, -1rem, 0);
    }
  }

  display: flex;
  justify-content: center;
  margin: 1rem;

  div {
    width: 1rem;
    height: 1rem;
    background: #000;
    border-radius: 50%;
    animation: bouncing-loader 0.6s infinite alternate;
  }
  div:nth-of-type(2) {
    animation-delay: 0.2s;
  }
  div:nth-of-type(3) {
    animation-delay: 0.4s;
  }
`

export default BouncingLoader
